
import { Vue, Options } from 'vue-class-component';

@Options({
  props: ['labels','switched', 'isChecked'],
  data() {
    return {
      title: this.labels,
      eLeft: null,
      eRight: null
    }
  },
  mounted(){
    if(this.isChecked){
      document.getElementsByClassName('switch-text-left')[0].classList.remove('switch-selected');
      document.getElementsByClassName('switch-text-right')[0].classList.add('switch-selected');
      document.getElementById("slider").click();
    } else {
      document.getElementsByClassName('switch-text-left')[0].classList.add('switch-selected');
      document.getElementsByClassName('switch-text-right')[0].classList.remove('switch-selected');
    }
  },
  methods: {
    onSwitch(checked: any) {
      if (!this.eLeft) {
        this.eLeft = document.getElementsByClassName('switch-text-left')[0];
      }
      if (!this.eRight) {
        this.eRight = document.getElementsByClassName('switch-text-right')[0];
      }
      this.$nextTick(() => {
        this.switched(checked.target.checked)
        if (checked.target.checked) {
          this.eLeft.classList.remove('switch-selected');
          this.eRight.classList.add('switch-selected');
        } else {
          this.eRight.classList.remove('switch-selected');
          this.eLeft.classList.add('switch-selected');
        }
      })
    }
  }
})

export default class ToggleSwitch extends Vue {

}

